import React from "react";
import CBTimage from "../../../assets/CBT.png";
import {
  Diagram3,
  ClockHistory,
  CalendarCheck,
  People,
  Lightbulb,
  Check2
} from "react-bootstrap-icons";

function TherapyIcon({ name }) {
  if (name === "brain") return <Diagram3 className="therapy-icon" />;
  if (name === "history") return <ClockHistory className="therapy-icon" />;
  if (name === "today") return <CalendarCheck className="therapy-icon" />;
  if (name === "sessions") return <People className="therapy-icon" />;
  if (name === "idea") return <Lightbulb className="therapy-icon" />;
  return null;
}

function CheckIcon() {
  return <Check2 className="therapy-check" />;
}

export default function CBTModal({ setShow }) {
  return (
    <>
      <div
        className="therapy-modal-backdrop"
        onClick={() => setShow(false)}
      />

      <div
        className="modal fade show d-block therapy-modal-wrap"
        tabIndex="-1"
        role="dialog"
        aria-modal="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg therapy-modal-dialog">
          <div className="modal-content therapy-modal-content">
            <div className="therapy-modal-hero">
              <div className="therapy-modal-hero-inner text-center">
                <img
                  src={CBTimage}
                  className="img-fluid mx-auto d-block mb-3"
                  alt="CBT"
                />

                <h5 className="therapy-modal-title">
                  What is CBT
                </h5>

                <div className="therapy-modal-subtitle">
                  Cognitive Behavioural Therapy explained
                </div>
              </div>

              <button
                type="button"
                className="btn-close therapy-modal-close"
                onClick={() => setShow(false)}
                aria-label="Close"
              />
            </div>

            <div className="modal-body therapy-modal-body">
              <div className="therapy-modal-card">
                <div className="therapy-modal-item">
                  <div className="therapy-modal-item-icon">
                    <TherapyIcon name="brain" />
                  </div>
                  <div className="therapy-modal-item-content">
                    <div className="therapy-modal-item-title">
                      Cognitive Behavioural Therapy
                    </div>
                    <div className="therapy-modal-item-text">
                      CBT is a talking therapy that helps you understand how
                      thoughts, feelings, and behaviours are connected. It
                      focuses on identifying unhelpful thinking patterns and
                      learning practical ways to change them.
                    </div>
                  </div>
                </div>

                <div className="therapy-modal-item">
                  <div className="therapy-modal-item-icon">
                    <TherapyIcon name="history" />
                  </div>
                  <div className="therapy-modal-item-content">
                    <div className="therapy-modal-item-title">
                      The Beginnings of CBT
                    </div>
                    <div className="therapy-modal-item-text">
                      The theory behind cognitive behavioural therapy is that
                      actions are a product of feelings, which are shaped by
                      thoughts and beliefs. It was first researched in the
                      1960s by Dr Aaron Beck at the University of Pennsylvania.
                    </div>
                  </div>
                </div>

                <div className="therapy-modal-item">
                  <div className="therapy-modal-item-icon">
                    <TherapyIcon name="today" />
                  </div>
                  <div className="therapy-modal-item-content">
                    <div className="therapy-modal-item-title">
                      CBT Today
                    </div>
                    <div className="therapy-modal-item-text">
                      Modern CBT methods are both problem centred and action
                      based. This means they are used to address specific
                      problems and teach strategies for managing those
                      problems.
                    </div>
                  </div>
                </div>

                <div className="therapy-modal-item">
                  <div className="therapy-modal-item-icon">
                    <TherapyIcon name="sessions" />
                  </div>
                  <div className="therapy-modal-item-content">
                    <div className="therapy-modal-item-title">
                      CBT Sessions
                    </div>
                    <div className="therapy-modal-item-text">
                      CBT sessions can be carried out in a variety of settings,
                      from one to one meetings to group sessions with other
                      people.
                    </div>
                  </div>
                </div>

                <div className="therapy-modal-callout">
                  <div className="therapy-modal-callout-icon">
                    <TherapyIcon name="idea" />
                  </div>
                  <div className="therapy-modal-callout-text">
                    <span className="therapy-modal-callout-strong">
                      Because CBT is goal based,
                    </span>{" "}
                    therapists often give assignments between sessions. These
                    may include reading or completing specific tasks to
                    support progress.
                  </div>
                </div>

                <div className="therapy-modal-split">
                  <div className="therapy-modal-split-left">
                    <div className="therapy-modal-item-title mb-2">
                      CBT helps clients to
                    </div>

                    <div className="therapy-modal-checklist">
                      <div className="therapy-modal-check">
                        <CheckIcon />
                        <div>
                          Recognise troubling or upsetting life circumstances
                        </div>
                      </div>

                      <div className="therapy-modal-check">
                        <CheckIcon />
                        <div>
                          Confront negative or inaccurate thoughts and replace
                          negative behaviours with positive habits
                        </div>
                      </div>

                      <div className="therapy-modal-check">
                        <CheckIcon />
                        <div>
                          Develop awareness of personal thoughts and opinions
                          about situations
                        </div>
                      </div>

                      <div className="therapy-modal-check">
                        <CheckIcon />
                        <div>
                          Identify and challenge thoughts that are negative or
                          inaccurate
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="therapy-modal-split-right">
                    <div className="therapy-modal-note">
                      Sessions are adapted to the individual rather than
                      following a one size fits all approach. Frequency may
                      reduce over time as recovery progresses. The skills
                      learned through CBT often remain long after treatment
                      ends and are most effective when used as part of a
                      broader treatment and rehabilitation programme.
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="modal-footer therapy-modal-footer">
              <button
                className="btn btn-brand-white fw-semibold therapy-modal-footer-btn"
                onClick={() => setShow(false)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

